var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconTiktokLogo = function SvgIconTiktokLogo(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "M11 2.625a1 1 0 0 1 1-1h3.75a1 1 0 0 1 1 1A4.25 4.25 0 0 0 21 6.875a1 1 0 0 1 1 1v3.75a1 1 0 0 1-1 1 10 10 0 0 1-4.25-.946v2.945A7.376 7.376 0 0 1 2.346 16.86a7.375 7.375 0 0 1 5.728-9.491 1 1 0 0 1 1.176.984v3.9a1 1 0 0 1-.571.904A1.625 1.625 0 1 0 11 14.625zm2 1v11a3.625 3.625 0 1 1-5.75-2.937V9.691a5.373 5.373 0 0 0-2.998 6.563 5.375 5.375 0 0 0 10.498-1.629V9.939a1 1 0 0 1 1.583-.813A8 8 0 0 0 20 10.563V8.795a6.25 6.25 0 0 1-5.17-5.17z",
    clipRule: "evenodd"
  })));
};
export default SvgIconTiktokLogo;